import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useIdelinkTheme } from '../../../configs/IdeLinkTheme';
import { ItemState } from '../../../services/commons/ItemState';
import { AdminPermission } from '../../../services/commons/Me';
import {
    AdminPermissions,
    AdminPermissionsOnModule,
} from '../../../services/commons/Permissions/AdminPermissions';
import {
    ContentPermission,
    UserPermissions,
    UserPermissionsOnContent,
} from '../../../services/commons/Permissions/ContentPermission';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';
import { PermissionType } from '../../../services/commons/Permissions/PermissionType';
import { TabPermissionItem } from '../../BackUsers/Pages/components/PermissionsTreeContainer/PermissionsTreeContainer';

export interface UserPermissionsOnAudits extends AdminPermissionsOnModule {
    canExportHistory?: boolean;
}

export interface UserPermissionsOnAuditAutoCheck extends UserPermissionsOnContent {
    readonly canEditRecurrence?: boolean; //! Infos de récurrence (type, jours, heures)?:boolean
    readonly canEditContentEndDate?: boolean; //! Date de fin de récurrence
    readonly canEditThemes?: boolean;
    readonly canEditEnableNotificationOnCreate?: boolean;
    readonly canEditRoles?: boolean;
}

export class AuditsPermissions {
    public static AUDITS_TAB_HASH = '#rights-audits';
    public static AUDITS_CODE = 'Audits';

    public static Admin: UserPermissionsOnAudits = {};

    public static getAuditsTab = (): TabPermissionItem => ({
        hash: AuditsPermissions.AUDITS_TAB_HASH,
        label: <FormattedMessage id="backofficeUsers.create.tabs.permissions.sectionTabs.audits" />,
        getIcon: () => useIdelinkTheme().audits.permissionIcon,
        getIconSelected: () => useIdelinkTheme().audits.permissionSelectedIcon,
    });

    public static initializeAuditsAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnAudits = AdminPermissions.filter(perms, AuditsPermissions.AUDITS_CODE);
        AuditsPermissions.Admin = {
            ...AdminPermissions.toPermissions(permsOnAudits),
            canExportHistory: AdminPermissions.has(PermissionType.ContentCreate, permsOnAudits),
        };
        PermissionsAbilityHelper.logPermissions('Audits', AuditsPermissions.Admin);
    };

    public static toUserPermissionsOnAuditAutoCheck = (
        contentState: ItemState,
        contentPermission?: ContentPermission
    ): UserPermissionsOnAuditAutoCheck => {
        const canEdit = UserPermissions.canEdit(contentState, contentPermission);
        return {
            ...UserPermissions.toUserPermissionsOnContent(contentState, contentPermission),
            canEditContentEndDate: canEdit,
            canEditEnableNotificationOnCreate: canEdit,
            canEditRoles: canEdit,
            canEditRecurrence:
                (contentState === ItemState.Draft &&
                    UserPermissions.has(PermissionType.ContentEditDraft, contentPermission)) ||
                (contentState === ItemState.Unpublished &&
                    UserPermissions.has(PermissionType.ContentEditPublished, contentPermission)),
            canEditThemes:
                (contentState === ItemState.Draft &&
                    UserPermissions.has(PermissionType.ContentEditDraft, contentPermission)) ||
                (contentState === ItemState.Unpublished &&
                    UserPermissions.has(PermissionType.ContentEditPublished, contentPermission)),
            canEditAudiences:
                (contentState === ItemState.Draft &&
                    UserPermissions.has(PermissionType.ContentEditDraft, contentPermission)) ||
                (contentState === ItemState.Unpublished &&
                    UserPermissions.has(PermissionType.ContentEditPublished, contentPermission)),
        };
    };
}
